"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventFormattedFiltersMap = void 0;
const shared_1 = require("../../types/binance/websockets/shared");
const spot_1 = require("../../types/binance/websockets/spot");
const spotMarketEventsFilter = messages => {
    return messages.filter(event => event.eventType === spot_1.EWsBinanceSpotMarketEventTypes.individualTicker);
};
const spotOrderEventsFilter = messages => {
    return messages.filter(event => event.eventType === spot_1.EWsBinanceSpotEventsTypes.executionReport);
};
const spotAccountEventsFlter = messages => {
    return messages.filter(event => event.eventType === spot_1.EWsBinanceSpotEventsTypes.outboundAccountPosition);
};
const futuresUsdmOrdersEventsFlter = messages => {
    return messages.filter(event => event.eventType === shared_1.EWsBinanceFuturesEventTypes.ORDER_TRADE_UPDATE);
};
const futuresBalanceAndPositionsEventsFlter = messages => {
    return messages.filter(event => event.eventType === shared_1.EWsBinanceFuturesEventTypes.ACCOUNT_UPDATE);
};
const usdmMarketPriceFilter = messages => {
    return messages.filter(event => event.eventType === shared_1.EWsBinanceFuturesMarketEventTypes.markPriceUpdate);
};
exports.eventFormattedFiltersMap = {
    [spot_1.EWsBinanceSpotMarketEventTypes.individualTicker]: spotMarketEventsFilter,
    [spot_1.EWsBinanceSpotEventsTypes.executionReport]: spotOrderEventsFilter,
    [spot_1.EWsBinanceSpotEventsTypes.outboundAccountPosition]: spotAccountEventsFlter,
    [shared_1.EWsBinanceFuturesEventTypes.ORDER_TRADE_UPDATE]: futuresUsdmOrdersEventsFlter,
    [shared_1.EWsBinanceFuturesEventTypes.ACCOUNT_UPDATE]: futuresBalanceAndPositionsEventsFlter,
    [shared_1.EWsBinanceFuturesMarketEventTypes.markPriceUpdate]: usdmMarketPriceFilter
};
